import "./Table.css"
var DeveloperPortalCompaniesRow = function(props){
    return <div title={unescape(props.description)} className="c_developerportal_companies_row row">
        <div className="col-md-2">{props.serialid}</div>
        <div className="col-md-5">{unescape(props.company)}</div>
        <div className="col-md-5"><button className="c_developerportal_buttononwhite" onClick={props.getDetails.bind(null, props.serialid)}>Details</button></div>
    </div>
}
export default DeveloperPortalCompaniesRow